import {GitHubAvatar} from '@github-ui/github-avatar'
import {Link} from '@primer/react'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import type {User} from '@github-ui/user-selector'

import styles from './User.module.css'

export function User({user}: {user: User}) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()

  return (
    <>
      <Link
        aria-label={`View ${user.login} profile`}
        href={user.path}
        {...getHovercardAttributesForType('user', {login: user.login})}
      >
        <GitHubAvatar
          src={user.primaryAvatarUrl}
          square={user.path.startsWith('/apps/')}
          className={styles.GitHubAvatar}
        />
      </Link>
      <Link
        muted
        href={user.path}
        {...getHovercardAttributesForType('user', {login: user.login})}
        className={styles.Link}
      >
        {user.login}
      </Link>
    </>
  )
}
